// extracted by mini-css-extract-plugin
module.exports = {"warningIcon":"PaymentRowWarningIcon_warningIcon__8UDdX"};